import React from 'react';
import {TimeSpan} from "@sparkware/app-utils";
import {IStandardToastContentProps} from "../../components/toaster/toasts-content/standard-toast.component.props";

export interface IToastHandler {
    readonly toastId: number | string;
    close(closeReason?: ToastCloseReason | string): void;
}

interface IToastOptions {
    timeout?: TimeSpan;
    hideProgressBar?: boolean;
    className?: string;
    closeButton?: boolean;
}



export enum ToastCloseReason {
    CloseButton = "CloseButton",
}

export interface IToastDefinition {
    id?: number | string;
    toastOptions?: IToastOptions;
    renderContent: (handler: IToastHandler) => React.ReactElement;
    onToastShown?: () => void;
    /**
     * Use this if you need to monitor a state that can change at any time.
     * For example, to postpone the toast while a game is opened, or to postpone while an overlay is on the screen
     * @returns boolean
     */
    displayCondition?: () => boolean;
    /**
     * Use this if you need to postpone the toast until a promise is resolved
     */
    waitFor?: Promise<unknown>;
    /**
     * @param closeReason ToastCloseReason | string | undefined
     * closeReason will be ToastCloseReason.CloseButton if the toast is closed from X button or undefined if it's autoClosed by the timeout or whatever you pass to the handler close method
     * Keep in mind that if you don't pass an argument to the close method the reason will be undefined just as in the case of timeout
     */
    onToastClosed?: (closeReason?: ToastCloseReason | string) => void;
}

export interface IStandardToastDefinition extends Omit<IToastDefinition, "renderContent"> {
    contentProps: IStandardToastContentProps;
}

interface IAnalyticsData {
    category: string;
    action: string;
    label?: string;
}

export interface IAnalyticsOptions {
    analyticsData?: IAnalyticsData;
}

export interface IToasterService {
    readonly hasOpenToasters: boolean;
    showCustomToast(toastDef: IToastDefinition): IToastHandler;// Promise<IToasterHandler>;
    showStandardToast(toastDef: IStandardToastDefinition): IToastHandler;
    showAckStandardToast(toastDef: IStandardToastDefinition): IToastHandler;
    removeAllToasts: () => void;
}
